import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-add-fishery-dialog',
    templateUrl: './add-fishery-dialog.component.html',
    styleUrls: ['./add-fishery-dialog.component.css'],
    standalone: false
})
export class AddFisheryDialogComponent {
  selectedOption!: string;

  selectError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddFisheryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {groundfishFishery: boolean, hmsFishery: boolean, trawlFishery: boolean},
  ) {
    // Determine which radio button should be selected by default
    if (data.trawlFishery) {
      this.selectedOption = 'trawl';
    } else if (data.groundfishFishery && data.hmsFishery) {
      this.selectedOption = 'both';
    } else if (data.groundfishFishery) {
      this.selectedOption = 'groundfishNonTrawl';
    } else if (data.hmsFishery) {
      this.selectedOption = 'hms';
    } else {
      this.selectedOption = '';
    }
  }

  onBackClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    // If nothing is selected, show error and exit.
    if (!this.selectedOption) {
      this.selectError = true;
      return;
    }

    // Clear the error if the user has selected something
    this.selectError = false;
    this.dialogRef.close(this.selectedOption);
  }
}
